export enum DashboardRefreshMode {
    None = 0,
    Poll = 1,
    SignalR = 2
}
